import React, { useContext } from 'react';
import qs from 'qs';

import OrderContainer from '../containers/order/OrderContainer';
import PageTemplate from '../components/common/template/PageTemplate';
import ModalContext from '../modules/contexts/Modalcontext';
import AffiliateContext from '../modules/contexts/AffiliateContext';

const OrderPage = ({ location }) => {
  const query = qs.parse(location.search.substr(1));
  const status = query.imp_success;
  const errorMSG = query.error_msg;
  const imp_uid = query.imp_uid;
  const merchant_uid = query.merchant_uid;

  const { onModal } = useContext(ModalContext).actions;
  const affiliateContext = useContext(AffiliateContext);

  return (
    <PageTemplate title={PAGE_TITLE}>
      <OrderContainer
        status={status}
        errorMSG={errorMSG}
        imp_uid={imp_uid}
        merchant_uid={merchant_uid}
        onModal={onModal}
        affiliateContext={affiliateContext}
      />
    </PageTemplate>
  );
};

export default OrderPage;

const PAGE_TITLE = '신청서';
